export var Country;
(function (Country) {
    Country["Belgium"] = "BE";
    Country["Netherlands"] = "NL";
    Country["Luxembourg"] = "LU";
    Country["France"] = "FR";
    Country["Germany"] = "DE";
    Country["Sweden"] = "SE";
    Country["UnitedKingdom"] = "GB";
    Country["Switzerland"] = "CH";
    Country["Afghanistan"] = "AF";
    Country["CzechRepublic"] = "CZ";
    Country["UnitedStates"] = "US";
    Country["Austria"] = "AT";
    Country["Portugal"] = "PT";
    Country["Other"] = "OTHER";
})(Country || (Country = {}));
//# sourceMappingURL=Country.js.map